<template>
	<img
			v-if="imageUrl"
			:src="`${imageUrl}${sanityFormatAndSizeParameters}`"
			:height="imageObject.height"
			:width="imageObject.width"
			loading="lazy"
			alt=""
	/>
</template>
<script lang="ts" setup>
	import {computed} from 'vue';
	import {useRuntimeConfig} from '#app';
	import type {PortableTextComponentProps} from '@portabletext/vue';
	import {createSanityCdnImageUrl, sanityImageObjectFromRef} from '~/lib/sanityImageHelper';

	const props = defineProps<
		PortableTextComponentProps<{ 'asset': { '_ref': string } }>
	>();

	const runtimeConfig = useRuntimeConfig();
	const publicSanityConfig = runtimeConfig.public.sanity;

	const imageObject = computed(() => sanityImageObjectFromRef(props.value.asset._ref));

	const imageUrl = computed(() => {
		if (!imageObject.value) {
			return null;
		}
		return createSanityCdnImageUrl(publicSanityConfig.projectId, publicSanityConfig.dataset, imageObject.value);
	});

	/**
	 * Parameters to downsize the image to a maximum of 896x896 pixels
	 * fit=max: resize the image to fit within the specified width and height, no stretching or upscaling
	 * auto=format: automatically convert the image to the best format for the browser
	 * 896px is the maximum width of content inside the card body
	 */
	const sanityFormatAndSizeParameters = '?auto=format&&w=896&h=896&fit=max';
</script>

<style scoped>
	img {
		max-width: 100%;
		height: auto;
		border: none;
		vertical-align: middle;
	}
</style>
